import React  from "react";
import {Calendar} from "./page/FullCalendar";

export function CalendarPage () {
    return <Calendar/>
}
